import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/slick-theme.css'
import './assets/css/slick.css'
import './assets/css/style.css'
import * as funcHelper from './helpers/funcHelper'
import * as authHelper from './helpers/authHelper'

import { configs } from './common/config'

const pinia = createPinia()
const Vue = createApp(App)

Vue.use(pinia)
Vue.use(router)
Vue.use(ElementPlus)

/* GLOBAL METHOD */
Vue.config.globalProperties._gFunc = funcHelper;
Vue.config.globalProperties._gAuth = authHelper;

Vue.config.globalProperties._vConf = configs;

Vue.mount('#app')